module.exports = __webpack_public_path__ + "images/home/product/features-todolist-bf522438d57ed79e08679c97dbccdb46.png";